import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FinfraStudioPageTopBreadcrumbService {
  public breadCrumb: any[] = [];
  public showBreadCrumb = false;

  public reset(): void {
    this.breadCrumb = [];
  }

  public pop(): void {
    this.breadCrumb.splice(this.breadCrumb.length, 1);
  }

  public push(value: any): void {
    this.breadCrumb.push(value);
  }
}

